(() => {
  const bind = () => {
    document.querySelectorAll('.op-nav').forEach(nav => {
      if (nav.dataset.bound) return;
      nav.dataset.bound = 'true';
      nav.addEventListener('toggle', event => {
        const target = event.target;
        if (!(target instanceof HTMLDetailsElement) || !target.open) return;
        nav.querySelectorAll('details[open]').forEach(other => { if (other !== target) other.open = false; });
      }, true);
    });
  };
  document.addEventListener('click', event => {
    if (!event.target.closest('.op-menu')) document.querySelectorAll('.op-menu[open]').forEach(menu => { menu.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.op-menu[open],.op-mobile[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  document.addEventListener('shopify:section:load', bind);
})();
